const agentConfigs = [
  {
    key: 'briefing',
    name: 'Agente Briefador',
    color: '#007AFF',
    tagline: 'Assistente Geral',
    adminOnly: false,
  },
  {
    key: 'conteudo',
    name: 'Agente de Conteúdo',
    color: '#FF9500',
    tagline: 'Monitorando Tendências',
    adminOnly: false,
  },
  {
    key: 'estrategico',
    name: 'Agente de Estratégia',
    color: '#AF52DE',
    tagline: 'Análise Profunda',
    adminOnly: false,
  },
  {
    key: 'redacao',
    name: 'Agente de Redação',
    color: '#dbff10',
    tagline: 'Criação de Conteúdo',
    adminOnly: false,
  },
  {
    key: 'roteiro',
    name: 'Agente de Roteiro',
    color: '#c60000',
    tagline: 'Desenvolvimento de Roteiros',
    adminOnly: false,
  },
  {
    key: 'pim',
    name: 'Agente de PIM',
    color: '#ee90e9',
    tagline: 'Planejamento Integrado de Marcas',
    adminOnly: false,
  },
  {
    key: 'agente-gov',
    name: 'Agente GovMS',
    color: '#0c8322',
    tagline: 'Análise de Dados',
    adminOnly: true,
  },
];
 
export default agentConfigs;